import { SelectInput } from '@life-line-lab/components-react';
import React, { ReactNode } from 'react';
import { countriesStates } from 'Data/countriesStates';

interface AdditionalFilter {
  /**
   * @example
   * "MY" // for Malaysia
   */
  countryCode?: string;
}

interface StateSelectorProps {
  label: ReactNode;
  value: string;
  name: string;
  placeholder: string;
  onChange: (value: string | string[]) => any;
  isRequired: boolean;
  additionalFilter: AdditionalFilter;
  [key: string]: any;
}

const StateSelector = ({
  value,
  label,
  name,
  placeholder,
  onChange,
  isRequired,
  additionalFilter,
  ...props
}: StateSelectorProps) => {
  const getStateOptions = (country?: string): any[] => {
    if (!country) return [];

    const foundCountry = countriesStates.find((countryObj) => countryObj.code === country);
    if (!foundCountry?.states) return [];

    return foundCountry.states.map((stateName) => ({
      label: stateName,
      value: stateName,
    }));
  };

  return (
    <SelectInput
      label={label}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      isRequired={true}
      options={getStateOptions(additionalFilter.countryCode)}
      showSearch={true}
      filterOption={(input: string, option: any) =>
        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    />
  );
};

export default StateSelector;
